import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Alert, IconButton, Snackbar, SnackbarOrigin } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { closeSnackbar } from 'main/store/common/reducer';
import { selectSnackbarState } from 'main/store/common/selectors';

const ANCHOR_ORIGIN: SnackbarOrigin = { vertical: 'bottom', horizontal: 'center' };

export const AlertSnackbar = () => {
    const dispatch = useDispatch();
    const { severity, message } = useSelector(selectSnackbarState);

    const handleClose = useCallback(() => {
        dispatch(closeSnackbar());
    }, [dispatch]);

    return (
        <Snackbar
            open={Boolean(message)}
            anchorOrigin={ANCHOR_ORIGIN}
            onClose={handleClose}
            sx={{ pb: 8 }}
        >
            <Alert
                severity={severity}
                action={
                    <IconButton color="inherit" size="small" onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                }
            >
                {message}
            </Alert>
        </Snackbar>
    )
}
